<template>
  <v-card width="350px" light class="rounded-md">
    <v-card-title
      primary-title
      style="background-color: black; text-align: left"
      class="pa-6"
      color="white"
    >
      <span style="font-family: Inter; color: white" class="text-h5">
        <v-icon color="white" style="margin-top: -5px"
          >mdi-shield-account</v-icon
        >
        Admin Access
      </span>
    </v-card-title>
    <v-col class="pa-6">
      <v-card-text class="pa-0" color="black">
        <v-icon size="small" style="margin-top: -4px" color="black"
          >mdi-key-variant</v-icon
        >
        <span style="font-family: Inter; font-weight: 600">
          Password
        </span></v-card-text
      >
      <v-text-field
        v-model="password"
        hide-details
        outlined
        dense
        light
        color="black"
        class="mb-6"
        type="password"
        placeholder="•••••••••"
        @keyup.enter="callLogIn"
      >
      </v-text-field>
      <v-card-text v-if="error.length > 0" class="pa-0 mb-6" color="red">
        <span style="font-family: Inter; font-weight: 400; color: red">
          {{ error }}
        </span></v-card-text
      >
      <div style="text-align: right">
        <v-btn
          large
          depressed
          text
          class="ml-4 rounded-md no-active-btn"
          @click="$emit('cancel')"
        >
          <span
            style="
              font-family: Inter;
              text-transform: none;
              font-weight: 600;
              margin-top: -3px;
            "
            >Cancel</span
          >
        </v-btn>
        <v-btn
          depressed
          large
          color="black"
          class="rounded-md ml-4 white--text pr-3"
          @click="callLogIn"
        >
          <span
            style="
              font-family: Inter;
              text-transform: none;
              font-weight: 600;
              margin-top: -3px;
            "
            >Login</span
          >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import loginService from '../../../services/loginService';

export default {
  data() {
    return {
      password: '',
      error: '',
    };
  },
  mounted() {},
  methods: {
    ...mapActions(['logIn']),
    async callLogIn() {
      let result = await loginService.login(this.password);
      if (result.success) {
        this.logIn(result.accessToken);
        this.$emit('confirm');
      } else {
        this.error = 'The password you entered is incorrect';
      }
    },
  },
};
</script>

<style></style>
